import React, { useContext, useEffect, useState } from 'react'
import CoworkersItem from './CoworkersItem'
import Loading from '../../components/Loading'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './coworkers.module.css'

export default function Coworkers() {
  const [arr, setArr] = useState([])
  const [loading, setLoading] = useState(false)
  const [updateed, setUpdated] = useState(false)
  const {offset, setOffset, setOffsetUpdated, selectedLang} = useContext(store)
  const limit = 20

  let lang = translate[selectedLang]

  useEffect(() => {
    setOffset(0)
    setUpdated(true)
  }, [])

  useEffect(() =>{
    (async() => {
      if(updateed){
        setLoading(true)
        const res = await axiosInstance.get(`/use/partners?offset=${offset}&limit=${limit}`)
        if(res.data.status){
          setArr([...arr,...res.data.data])
          if(res.data.data.length == 20){
            setOffsetUpdated(false)
          }
        }else{
          setArr([...arr])
        }
        setLoading(false)
      }
    })()
  }, [offset, updateed])

  return (
      <div className={styles['coworkers-list']}>
        <div className={styles['coworkers-list-div']}>
            <p className={styles['coworkers-category']}>{lang.tr_partners}</p>
            {arr.length ? 
              <div>
            
                {arr.map((el) => <CoworkersItem key={el._id} el={el}/>)}
              </div>
            :
            !loading ? <p className='empty-message'>{lang.tr_noPublished}</p> : null}
            {loading ? <Loading width={200}/> : ""}
            
        </div>
      </div>
  )
}
